import { generateClassName } from '@klv/shared/utils/functions';
import Buttons from '@klv/molecules/buttons';
import Icon from '@klv/atoms/icon';
import { designSystemColors } from '@klv/shared/styles/colors';

import * as s from './styles/textTagline.module.css';

import type { ITextTagline } from './types';

const TextTagline = ({
  buttons,
  headline = '',
  headlineColor = 'sage',
  subhead = '',
  ...props
}: ITextTagline) => (
  <div className="defaultPaddingTop defaultPaddingBottom" {...props}>
    <div className={generateClassName([s.grid, 'grid'])}>
      <Icon
        className={s.flag}
        fillColor='currentColor'
        iconName='BugMarkFilled'
      />
      <h1
        className={generateClassName([s.headline, 'bold'])}
        dangerouslySetInnerHTML={{ __html: headline }}
        style={{
          '--headline-color': designSystemColors[headlineColor],
        } as React.CSSProperties}
      />
      {(subhead !== '') && (
        <div className={generateClassName([s.subhead, 'h4'])}>{subhead}</div>
      )}
      {(buttons && buttons.length > 0) && (
        <Buttons
          className={s.buttons}
          buttonColor='dark'
          buttons={buttons}
          variants={['primary', 'ghost']}
        />
      )}
    </div>
  </div>
);

export default TextTagline;
